// extracted by mini-css-extract-plugin
export default {"thanks":"+-tkL","logoContainer":"F4Dw+","logo":"BCpZO","toast":"k+GHJ","title":"Tvq0J","invoiceNum":"pqvBm","message":"ELcjU","finishBtn":"N-FcM"};